import type { Editor } from '@tiptap/react';
import { EditorContent } from '@tiptap/react';
import { cn } from '@simplywallst/ui-core/next';

interface Props {
  editor: Editor;
}

const editorBaseClasses = cn([
  'w-full',
  'text-solid',
  'text-base',
  'prose',
  'max-w-none',
  'prose-p:text-base',
  'prose-h3:text-mega',
  'prose-h4:text-xl',
  'prose-h5:text-lg',
  '[&_.ProseMirror>*]:first:mt-0',
  '[&_.is-editor-empty]:before:absolute',
  '[&_.is-editor-empty]:before:text-softer',
  '[&_.is-editor-empty]:before:float-left',
  '[&_.is-editor-empty]:before:pointer-events-none',
  '[&_.is-editor-empty]:before:content-[attr(data-placeholder)]',
]);

export const RichTextEditorInput = ({ editor }: Props) => (
  <EditorContent className={editorBaseClasses} editor={editor} />
);
